import {
  AppContext,
  SkeletonTableLoading,
  useIntl,
  getTranslatedText
} from '@nile/components';
import React, { useContext, useState, useEffect } from 'react';
import { pageSize } from '@nile/rmm/src/modules/asset-management/constants/asset-list';
import { AccountClient, GET_OVERAGE_DEVICES_LIST } from '@nile/graphql';
import { useLazyQuery } from '@apollo/client';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import { assetDetailsTab } from '@nile/rmm/src/modules/alert-management/constants/constants';
import { SuperTable } from '@nile/components';
import TextCell from '@nile/banyan/src/Components/Tables/TextCell';
import { DateTimeCell } from '@nile/rmm/src/modules/asset-management/components/sub-pages/executed-scripts/cells';
import { Banner, Page, TextStyle } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import dayjs from 'dayjs';

function ItOverageDeviceList(props) {
  const {
    setOpenOverageAssetModal,
    openOverageAssetModal,
    overageBillingPeriod
  } = props;
  const appContext = useContext(AppContext);
  const tabContext = useContext(TicketContext);
  const { user } = appContext;
  const [totalCount, setTotalCount] = useState(0);
  const intl = useIntl();
  const [assetListData, setAssetListData] = useState();
  const [listInfoDetails, setListInfoDetails] = useState();

  const defaultOptions = {
    billableItems: false,
    listInfoInput: {
      page: 1,
      pageSize: pageSize,
      sort: [
        {
          attribute: 'itemName',
          order: 'DESC'
        }
      ],
      condition: null
    }
  };

  const [getExecutedScriptsList, { loading, error }] = useLazyQuery(
    GET_OVERAGE_DEVICES_LIST,
    {
      client: AccountClient,
      fetchPolicy: 'no-cache',
      onCompleted: ({ getOverageItems: data }) => {
        setTotalCount(data?.listInfo.totalCount || 0);
        setListInfoDetails(data?.listInfo);
        setAssetListData(data?.overageItems);
      }
    }
  );

  useEffect(() => {
    getExecutedScriptsList({ variables: defaultOptions });
  }, []);

  const columnsConfig = {
    TEXT: TextCell,
    DATE: DateTimeCell
  };

  const navToAssetDetailsPage = (obj) => {
    const { assetId, name, assetClass } = obj?.row?.original || {};
    tabContext.openTab({
      module: assetDetailsTab,
      data: {
        id: assetId,
        subject: name,
        classId: assetClass?.classId
      }
    });
  };

  const cols = [
    {
      id: 'AssetName',
      name: getTranslatedText(intl, 'common.name'),
      key: 'itemName',
      type: 'TEXT',
      width: 200
    },
    {
      id: 'InstalledDate',
      key: 'startDateTime',
      type: 'DATE',
      name: getTranslatedText(intl, 'attribute.installedDate')
    },
    {
      id: 'UninstalledDate',
      key: 'endDateTime',
      type: 'DATE',
      name: getTranslatedText(intl, 'app.attribute.uninstalledDate')
    }
  ];

  const columns = cols.map((item) => {
    return {
      header: item.name,
      accessorKey: item.key,
      minSize: item?.width,
      size: 150,
      id: item.key,
      type: item.type,
      disableSortBy: item.id == 'AssetName' ? false : true,
      disableFilters: true,
      disableResizing: false,
      width: 150,
      field: {
        name: item.key,
        label: item.name
      }
    };
  });

  return (
    <Page
      variant="secondary"
      contentHeight="180px"
      disableScroll
      title={
        <TextStyle weight="Bold">
          {getTranslatedText(
            intl,
            'itsm.app.pricing.overage.device.list.table.header'
          )}
          {overageBillingPeriod?.startDateTime &&
            overageBillingPeriod?.endDateTime &&
            ` ${dayjs(overageBillingPeriod?.startDateTime)?.format(
              'DD/MM/YYYY'
            )} ${getTranslatedText(intl, 'asset.activity.data.to')} ${dayjs(
              overageBillingPeriod?.endDateTime
            )?.format('DD/MM/YYYY')}`}
        </TextStyle>
      }
      subtitle={
        <Banner status="warning" alignContent="left">
          <FormattedMessage id="itsm.app.pricing.overage.device.list.banner.info" />
        </Banner>
      }
      breadcrumbs={[
        {
          onAction: () => {
            if (setOpenOverageAssetModal) {
              setOpenOverageAssetModal(!openOverageAssetModal);
            }
          },
          content: 'Back'
        }
      ]}
    >
      {!assetListData ? (
        <SkeletonTableLoading borderTop />
      ) : (
        <SuperTable
          context={{
            records: [],
            viewConditions: []
          }}
          data={assetListData}
          listInfo={listInfoDetails}
          user={user}
          rowCount={pageSize}
          recordCount={totalCount}
          fullHeight
          columns={[{ Header: 'Name', header: 'name', columns: columns }]}
          defaultColumnCells={columnsConfig}
          noBulkSelect
          refreshTable={(context, data) => {
            getExecutedScriptsList({
              variables: {
                ...defaultOptions,
                listInfoInput: {
                  ...defaultOptions.listInfoInput,
                  page: data?.page || 1,
                  sort: data?.sort
                }
              }
            });
          }}
          padded="sm"
          isLoading={loading}
        />
      )}
    </Page>
  );
}

export default ItOverageDeviceList;
